import styled from 'styled-components'
import React, {useEffect, useRef, useState} from 'react'
import InfoMasterclass from './InfoMasterclass'
import {AuthorsSlider, ProductsSlider, PromoAreaComponent, Section} from '../../common'
import useRest from '../../../hooks/useRest'
import {useNavigate, useParams} from 'react-router-dom'
import {Format, FormatProduct, Product, ProductItem, ProductType, Recommended} from 'types/rest'
import AuthorView from '../course/AuthorView'
import InfoLessonMobile from '../course/InfoContentMobile'
import {getLanguage, getTranslation, getUser} from '@store/selectors'
import {useSelector} from 'react-redux'
import useMediaQuery from '../../../hooks/useMediaQuery'
import {small} from '../../../constants'
import CourseShowPreview from '../course/CourseShowPreview'
import CourseShowTrailer from '../course/CourseShowTrailer'
import {logger} from "@helpers";
import RecommendedFormatCard from "./RecommendedFormatCard"
import InlineContentPlayer from "../../common/VideoPlayer/InlineContentPlayer"
import useTrackPageView from '../../../hooks/useTrackPageView'

/**
 * Componente vista per le course
 * @constructor
 */
const Masterclass: React.FC = () => {
  // determina se è stato premuto il tasto per riprodurre il trailer
  const [playTrailer, setPlayTrailer] = useState(false)
  // tiene traccia dell'ultima lezione di questo corso che l'utente stava guardando, se c'è
  // altrimenti seleziona il primo
  const [selectedItem, setSelectedItem] = useState<{ keep: boolean; item: ProductItem }>()
  // variabile per altezza del componente jumbo da passare a infoMasterclass per l'highlightButton
  const [jumboContainerHeight, setJumboContainerHeight] = useState()
  const [playContent, setPlayContent] = useState(false)
  const [currFormat, setCurrFormat] = useState<Format>()
  const [recomProdFromSameFormat, setRecomProdFromSameFormat] = useState<FormatProduct[]>()
  const [play] = useState(false)

  const user = useSelector(getUser)

  const jumboContainerRef = useRef(null)
  const translation = useSelector(getTranslation)

  const initialFilters = {
    withItems: true
  }

  const navigate = useNavigate()
  const language = useSelector(getLanguage)
  const isMobile = useMediaQuery(`(max-width: ${small})`)
  const {id} = useParams<{ id: string }>()
  const {result: product, getById} = useRest<Product>('products')
  const { get: getRecommended} = useRest<Recommended>('products/recommended', {initialFilters})
  const {get:getFormats,getById: getOneFormat,result: format, results: formats} = useRest<Format>('formats')

  const trackPageView = useTrackPageView()

  // cerco tra i prodotti di questo Maxxi Original tutti tranne il prodotto corrente (product.id) per graficare i ALtro da: ...
  useEffect(()=>{
    if(!format.products) return
    const filterProducts = format.products.filter((p)=> p.product.id !== product.id)
    setRecomProdFromSameFormat(filterProducts)
  },[format, product])

  useEffect(() => {
    if ((product?.type as ProductType)?.label === 'course') navigate('/')
  }, [product, navigate])

  // Prendo tutti i Maxxi Original
  useEffect(() => {
    trackPageView()
    getFormats().then().catch((e)=> console.error(e))
  },[])

  // Setto il formato corrente di questa pagina
  useEffect(() => {
    if(!product || !formats) return
    formats.map((f)=> f.products.map((p)=>{
      if(p.id === product.id) setCurrFormat(f)
    }))
  },[product, formats])

  useEffect(() => {
    if(!currFormat) return
    getOneFormat({id: `${currFormat.id}`}).then().catch((e)=> console.error(e))
  },[currFormat])

  // caricamente product e recommended con gestione
  useEffect(() => {
    getById({id})
      .then((result) => {
        if (result.keepWatching) {
          const item =  result.productItems.find((item)=> item.id === result?.keepWatching?.id)
          if(item) {
            setSelectedItem({
              keep: result?.keepWatching?.time!==0 ,
              item: {...result.keepWatching , video: item.video}
            })
          }
        } else {
          setSelectedItem({keep: false, item: result.productItems[0].children[0] ? result.productItems[0].children[0] : result.productItems[0]})
        }
      })
      .catch((err) => logger.error(err))
  }, [id, getById])

  useEffect(() => {
    if (!product.id) return
    getRecommended({
      filters: {excludeProduct: product.id, tags: product.tags || ''}
    }).catch((e) => logger.error(e))
  }, [selectedItem, getRecommended, product.id, product.tags])

  useEffect(() => {
    if (!jumboContainerRef.current) return
    setJumboContainerHeight((jumboContainerRef?.current as any)?.offsetHeight)
  },[(jumboContainerRef?.current as any)?.offsetHeight, setJumboContainerHeight])

  return (
      <Container>
            {selectedItem && (
                <JumboContainer play={play} isMobile={isMobile} ref={jumboContainerRef}>
                  {!playTrailer && !playContent &&
                      <CourseShowPreview
                          product={product}
                          setPlayContent={()=> setPlayContent(prev => !prev)}
                          selectedItem={selectedItem}
                          setPlayTrailer={setPlayTrailer}/>}
                  { playTrailer && !playContent &&
                      <CourseShowTrailer
                          product={product}
                          selectedItem={selectedItem.item}
                          setPlayTrailer={setPlayTrailer}/>}
                  {!playTrailer && playContent && selectedItem &&
                      <InlineContentPlayer
                          setPlayInline={()=> setPlayContent(prev=> !prev)}
                          product={product}
                          selectedItem={selectedItem} />}
                </JumboContainer>
            )}
            {product?.id && (!isMobile ? (
                <InfoMasterclass courseType={'masterclass'} purchased={product.purchased} data={product} detail={false} jumboContainerHeight={jumboContainerHeight}/>
            ) : (
                selectedItem && <InfoLessonMobile data={product}/>
            ))}
            {product.authors && product.authors.length > 0 && (
                <>
                  <Hr />
                      <Section>
                        {product.authors &&
                            id &&
                            product.authors.map((author) => <AuthorView key={author.id} author={author}
                                                                        productId={String(product?.id) || ''}/>)}
                      </Section>
                  <Hr />
                </>
            )}
{/*            {
                product?.purchased && product.attachments.length !== 0 && (
                    <Section>
                      <Attachments attachments={product.attachments}/>
                    </Section>
                )
            }*/}
            {/* Prodotti consigliati appartenenti alla stessa serie */}
            {format && recomProdFromSameFormat?.length! > 0 && <FormatSection>
              {<ProductsSlider<FormatProduct> id={format.id} slug={format.slug} title={`${translation.PAGES.classes.otherLessons}: ${format.translations[language].name}`}
                                        data={recomProdFromSameFormat!}
                                        CardComponent={RecommendedFormatCard}/>}
            </FormatSection>}
        {!user ?
          <PromoAreaComponent
            id={'not-sub-series'}
            infoType={'normal'}
            infoText={true}/> :
          <PromoAreaComponent
            infoText={true}
            id={'podcast'}/>
        }
            <AuthorsSlider/>
          </Container>
  )
}

export default Masterclass
const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: 3rem;
`
const JumboContainer = styled.div<{ play: boolean; isMobile?: boolean }>`
  width: 100%;
  overflow: ${(props) => (props.play ? 'auto' : 'hidden')};
  min-height: ${(props) => (props.play ? 'auto' : props.isMobile ? 'auto' : '39rem')};
  position: relative;
  &>div{animation: fadeInAnimation 1s;}
  @keyframes fadeInAnimation {
    from { opacity: 0; }
    to   { opacity: 1; }
}
`
const FormatSection = styled.div`
  width: 100%;
  margin: 3rem 0;
`

const Hr = styled.div`
  width: 100%;
  max-width: var(--max-content-width);
  height: 5px;
  margin: 0 auto;
  border-bottom: 5px solid #fff;
`


